// extracted by mini-css-extract-plugin
export default {"Divider":"_2U1UekW3UMTJ6Rs8u0-GPw==","ExtraMargin":"cjYueO2ex297ly2ZFLgbCg==","EqualMargin":"nV+Esg+YcCZ10XosCUgG5w=="};